import { ACTIVE, PENDING } from "components/constants";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import StatusPill from "utils/pills/StatusPill/StatusPill";
import Table from "utils/Table/Table";
import UsersFilters from "../common/UsersFilters";
import {
	providerTableData,
	userFiltersDefaultValues,
	userTableHeadings,
} from "../helpers/data";

const AllUsers = () => {
	const history = useHistory();
	const [formValues, setFormValues] = useState({
		...userFiltersDefaultValues,
	});

	const handleChange = ({ target: { name, value } }) =>
		handleSelect(name, value);

	const handleSelect = (name, value) => {
		console.log({ name, value });
		setFormValues((prev) => ({
			...prev,
			[name]: value,
		}));
	};
	const handleSubmit = () => setFormValues({ ...userFiltersDefaultValues });

	const getWalletData = () =>
		providerTableData?.map((wallet) => ({
			transactionID: wallet?.id,
			name: wallet?.name,
			email: wallet?.email,
			amount: wallet.phone,
			status: (
				<StatusPill
					status={wallet?.status}
					success={ACTIVE}
					warning={PENDING}
				/>
			),
			createdAt: wallet?.createdAt,
		}));

	const handleRowClick = (_, rowValues) => {
		history.push(`/users/${rowValues.transactionID}/details`);
	};
	return (
		<>
			<UsersFilters
				formValues={formValues}
				handleChange={handleChange}
				handleSubmit={handleSubmit}
				handleSelect={handleSelect}
			/>
			<Table
				data={getWalletData()}
				headings={userTableHeadings}
				rowClick={handleRowClick}
			/>
		</>
	);
};

export default AllUsers;
